import PropTypes from 'prop-types';
import React from 'react';
import {
  ROW_TYPE_FOUR_PRODUCTS,
  ROW_TYPE_FLEX_VIDEO,
  ROW_TYPE_FLEX_SERIES,
  ROW_TYPE_MULTI_STORY,
  ROW_TYPE_ONE_FEATURED_STORY,
  ROW_TYPE_ONE_STORY_HERO,
  ROW_TYPE_ONE_PRIME_CARD,
  ROW_TYPE_THREE_CHANNELS,
  ROW_TYPE_THREE_FEATURED_CARDS,
  ROW_TYPE_THREE_PREMIUM_CARDS,
  ROW_TYPE_THREE_PRIME_CARDS,
  ROW_TYPE_THREE_STANDARD_CARDS,
  ROW_TYPE_TWO_STANDARD_CARDS,
  ROW_TYPE_CTA_BAR,
  ROW_TYPE_FOUR_VIDEO,
  ROW_TYPE_HTML,
  ROW_TYPE_FEATURED_CATEGORY,
  ROW_TYPE_FLEX_CATEGORY,
  ROW_TYPE_TWO_CATEGORY,
  ROW_TYPE_MOST_POPULAR,
  ROW_TYPE_SUPER_SALE
} from '../../constants';
import { MODULE_TYPE_HERO } from '../module/mobile_content_module';
import HeroRow from './hero_row';
import ThreeStandardCardsRow from './three_standard_cards_row';
import TwoStandardCardsRow from './two_standard_cards_row';
import OnePrimeCardRow from './one_prime_card_row';
import ThreePremiumCardsRow from './three_premium_cards_row';
import ThreePrimeCardsRow from './three_prime_cards_row';
import ThreeFeaturedCardsRow from './three_featured_cards_row';
import MultiStoryRow from './multi_story_row';
import FourProductRow from './four_product_row';
import FlexVideoRow from './flex_video_row';
import FlexSeriesRow from './flex_series_row';
import ThreeChannelRow from './three_channel_row';
import CtaBarRow from './cta_bar_row';
import FourVideoRow from '../row/four_video_row';
import HtmlRow from '../row/html_row';
import FeaturedCategoryRow from '../row/featured_category_row';
import FlexCategoryRow from '../row/flex_category_row';
import TwoCategoryRow from '../row/two_category_row';
import MostPopularRow from './most_popular_row';
import SuperSaleRow from './super_sale_row';
import RowAd from '../ad/row_ad';
import {isEmpty} from 'lodash';

const shouldHideForRefresh = (type, isHomepageRefresh = false) =>
  isHomepageRefresh && [ROW_TYPE_CTA_BAR].includes(type);

const getRowComponent = ({ cards, type, isHomepageRefresh }) => {
  if (isEmpty(cards) || shouldHideForRefresh(type, isHomepageRefresh)) {
    return null;
  }

  switch (type) {
    case ROW_TYPE_ONE_STORY_HERO:
      return HeroRow;
    case ROW_TYPE_ONE_FEATURED_STORY:
      return isHomepageRefresh ? HeroRow : null;
    case ROW_TYPE_THREE_STANDARD_CARDS:
      return ThreeStandardCardsRow;
    case ROW_TYPE_THREE_FEATURED_CARDS:
      return ThreeFeaturedCardsRow;
    case ROW_TYPE_TWO_STANDARD_CARDS:
      return TwoStandardCardsRow;
    case ROW_TYPE_ONE_PRIME_CARD:
      return OnePrimeCardRow;
    case ROW_TYPE_THREE_PREMIUM_CARDS:
      return ThreePremiumCardsRow;
    case ROW_TYPE_MULTI_STORY:
      return MultiStoryRow;
    case ROW_TYPE_THREE_PRIME_CARDS:
      return ThreePrimeCardsRow;
    case ROW_TYPE_FOUR_PRODUCTS:
      return FourProductRow;
    case ROW_TYPE_FLEX_VIDEO:
      return FlexVideoRow;
    case ROW_TYPE_FLEX_SERIES:
      return FlexSeriesRow;
    case ROW_TYPE_THREE_CHANNELS:
      return ThreeChannelRow;
    case ROW_TYPE_CTA_BAR:
      return CtaBarRow;
    case ROW_TYPE_FOUR_VIDEO:
      return FourVideoRow;
    case ROW_TYPE_HTML:
      return HtmlRow;
    case ROW_TYPE_FEATURED_CATEGORY:
      return FeaturedCategoryRow;
    case ROW_TYPE_FLEX_CATEGORY:
      return FlexCategoryRow;
    case ROW_TYPE_TWO_CATEGORY:
      return TwoCategoryRow;
    case ROW_TYPE_MOST_POPULAR:
      return MostPopularRow;
    case ROW_TYPE_SUPER_SALE:
      return SuperSaleRow;
    default:
      return null;
  }
};

const getRowType = (
  { type, moduleType, indexWithinModule, breakpoint }
) => {
  /*
   * We want to show the first row of a feed module as a 3-prime instead of a
   * 3-standard. (Same with the Editors' Picks module below the fold on
   * article pages.)
   *
   * This is tough to accomplish on the backend, because Zeppelin returns
   * the same row types as the first page on every page. Therefore, it's tough
   * to have logic in Zeppelin that says "the first row only is 3-prime". It's
   * easier to just shim it here, in the frontend.
   *
   */
  if (['feed', 'editors-picks'].includes(moduleType)
    && indexWithinModule === 1
    && breakpoint !== 'mobile'
    && type === ROW_TYPE_THREE_STANDARD_CARDS) {
    return ROW_TYPE_THREE_PRIME_CARDS;
  }

  if (moduleType === MODULE_TYPE_HERO
    && type === ROW_TYPE_THREE_STANDARD_CARDS) {
    return ROW_TYPE_THREE_FEATURED_CARDS;
  }

  return type;
};

export const Row = (props) => {
  const newProps = {

    ...props,
    type: getRowType(props)
  };

  const RowComponent = getRowComponent(newProps);
  if (RowComponent === null) {
    return <span />;
  }

  const isModuleRow = () => {
    return {};
  };

  return (
    <div>
      <RowComponent {...newProps}
        dataAttributes={isModuleRow()}
      />
      {!isEmpty(newProps.adPosition) && <RowAd {...newProps} />}
    </div>
  );
};

export default Row;

Row.propTypes = {
  adsState: PropTypes.object.isRequired,
  archivesState: PropTypes.object,
  adPosition: PropTypes.string,
  adSizes: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)),
  breakpoint: PropTypes.string,
  isHomepageRefresh: PropTypes.bool,
  type: PropTypes.string.isRequired,
  cards: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number
  })).isRequired,
  rowID: PropTypes.number.isRequired,
  moduleID: PropTypes.number.isRequired,
  moduleTitle: PropTypes.string.isRequired,
  page_id: PropTypes.number.isRequired,
  page_type: PropTypes.string.isRequired,
  indexWithinModule: PropTypes.number.isRequired,
  indexWithinRow: PropTypes.number,
  moduleType: PropTypes.string.isRequired
};

Row.defaultProps = {
  adsState: {}
};

export const propTypes = Row.propTypes;
